import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
export default createBreakpoints({});
